import { choices, email, maxLength, minLength, number, required, Validator } from "react-admin";

// Constants
import { EMAIL_LENGTH_LIMITS, LENGTH_MFA_CODE, PASSWORD_LENGTH_LIMITS, TEXT_LENGTH_LIMITS } from "../constants/common";
import { PASSWORD_STRENGTH_RULES } from "../constants/passwordRules";

// Types
import { Role } from "../types/role.enum";

type ValidatorType = {
  email: Validator[];
  code: Validator[];
  password: Validator[];
  newPassword: Validator[];
  text: Validator[];
  mfa: Validator[];
  role: Validator[];
};

// Only applies to setting a brand-new password (first sign-in) - the plain
// `password` validator below is also used to enter an EXISTING password on
// normal sign-in, which must not be rejected for not matching today's rules.
const passwordComplexity: Validator = (value: string) => {
  if (!value) return undefined;

  const failedRule = PASSWORD_STRENGTH_RULES.find((rule) => !rule.regex.test(value));

  return failedRule?.message;
};

const useValidators = (): ValidatorType => {
  return {
    email: [required(), email(), minLength(EMAIL_LENGTH_LIMITS.MIN), maxLength(EMAIL_LENGTH_LIMITS.MAX)],
    code: [required()],
    password: [required(), minLength(PASSWORD_LENGTH_LIMITS.MIN), maxLength(PASSWORD_LENGTH_LIMITS.MAX)],
    newPassword: [required(), minLength(PASSWORD_LENGTH_LIMITS.MIN), maxLength(PASSWORD_LENGTH_LIMITS.MAX), passwordComplexity],
    mfa: [required(), number(), minLength(LENGTH_MFA_CODE), maxLength(LENGTH_MFA_CODE)],
    text: [required(), minLength(TEXT_LENGTH_LIMITS.MIN), maxLength(TEXT_LENGTH_LIMITS.MAX)],
    role: [required(), choices([Role.OPERATOR, Role.OWNER, Role.SUPERVISOR, Role.CUSTOMER])],
  };
};

export default useValidators;
